import 'angular:locale/data:en-GB';
import './apps/ecommerce-shop/src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
